<div *ngIf="cart$ | async as cart"
     data-cy="mb-submit-order-wrapper">
    <mb-submit-order-request *ngIf="!isPurchaseCheckout"
                             [requestItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_REQUEST, cart)"
                             [purchaseItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_MIX, cart)"
                             [totalPrice]="cart.totalPrice">
    </mb-submit-order-request>

    <mb-submit-order-price *ngIf="isPurchaseCheckout"
                           [purchaseItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_AVAILABLE, cart)"
                           [requestItemsNo]="getTotalQuantityOfTypeOfItems(constants.PRICE_REQUEST, cart)"
                           [totalPrice]="cart.totalPrice"
                           [showShippingTaxes]="false">
    </mb-submit-order-price>

    <div class="tw-mt-6 tw-border-solid tw-border-0 tw-border-t-2 tw-border-primary-orange"
         data-cy="mb-submit-order-totals">
      <ng-container *ngIf="isPurchaseCheckout">
        <div class="tw-flex tw-justify-between">
          <div class="mt-3"
               data-cy="mb-submit-order-title"
               [innerHTML]="'mbcommon.estimatedSubtotal' | cxTranslate">
          </div>
          <div class="tw-mt-3 tw-text-right" data-cy="mb-submit-order-price">
            <strong>{{cart.totalPrice.formattedValue}}</strong>
          </div>
        </div>
      </ng-container>
      <div class="tw-my-3 tw-tracking-normal tw-text-sm tw-mb-6" data-cy="mb-submit-order-step-info">
      <span
        [innerHTML]="(isPurchaseCheckout && 'submitBox.taxesInfo' || 'submitBox.requestInfo') | cxTranslate"></span>
      </div>

      <div class="tw-text-center"
           data-cy="mb-submit-order-checkout-btn">
        <!-- Todo convert to tailwind-->
        <button type="button"
                class="btn btn-lg btn-primary w-100 text-initial mb-buttons tw-w-full"
                (click)="beginCheckout()">
          <strong [innerHTML]="'submitBox.proceedToCheckout' | cxTranslate"></strong>
        </button>
      </div>
    </div>
    <div>
      <mb-payment-methods [addMargin]="true"></mb-payment-methods>
    </div>
  </div>

